import { ChevronRightIcon } from "lucide-react";
import { useState, type ReactNode } from "react";

import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from "~/components/ui/collapsible";
import { cn } from "~/lib/utils";

export function PullRequestSummarySection(props: {
  readonly title: string;
  readonly count?: number;
  readonly actions?: ReactNode;
  readonly children: ReactNode;
}) {
  const [open, setOpen] = useState(true);
  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <div className="sticky top-0 z-10 flex items-center border-t border-border/60 bg-background pr-4">
        <CollapsibleTrigger className="flex min-w-0 flex-1 items-center gap-1.5 px-4 py-3 text-left text-sm font-medium">
          <span>{props.title}</span>
          <ChevronRightIcon
            aria-hidden
            className={cn(
              "size-3.5 text-muted-foreground transition-transform motion-reduce:transition-none",
              open ? "rotate-90" : null,
            )}
          />
          {props.count === undefined ? null : (
            <span className="text-xs tabular-nums text-muted-foreground">{props.count}</span>
          )}
        </CollapsibleTrigger>
        {open ? props.actions : null}
      </div>
      <CollapsiblePanel>
        <div className="px-4 pb-4">{props.children}</div>
      </CollapsiblePanel>
    </Collapsible>
  );
}
